import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5ZM12 5.25C12.3797 5.25 12.6935 5.53215 12.7432 5.89823L12.75 6V11.25H18C18.4142 11.25 18.75 11.5858 18.75 12C18.75 12.3797 18.4678 12.6935 18.1018 12.7432L18 12.75H12C11.6203 12.75 11.3065 12.4678 11.2568 12.1018L11.25 12V6C11.25 5.58579 11.5858 5.25 12 5.25Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }